import(/* webpackMode: "eager" */ "/app/apps/egged/app/[locale]/not-found.tsx");
